import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "50px",
    padding: "30px 15px",
    minHeight: "calc(100vh - 213px)",
    [theme.breakpoints.up("md")]: {
      padding: "30px 15px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "15px 10px"
    }
  },
  [theme.breakpoints.up("md")]: {
    container
  },
  [theme.breakpoints.down("sm")]: {
    container: {
      marginRight: "auto",
      marginLeft: "auto",
    },
  },
  map: {
    marginTop: "70px"
  }
});

export default appStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx